import React, {
  Component
} from 'react';
import 'react-input-range/lib/css/index.css';
import SearchBarMobile from './SearchBarMobile'; // mobile
import { debounce } from 'lodash';
import { hideLoader } from '../../helpers/loader';
import { getSearchQueryUrl } from '../../helpers/searchBarHelper';
import { SEARCH_SUGGESTION_DEBOUNCE_INTERVAL } from './search_const';
import { getSearchSuggestions } from '../../actions/api';


class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchString: '',
      results: [],
    };
    this.debouncedSuggestions = debounce(this.handleNewRequest, SEARCH_SUGGESTION_DEBOUNCE_INTERVAL);
  }

  componentDidMount() {
    hideLoader();
  }

  saveResult = suggestions => {
    const {
      searchString
    } = this.state;

    let results = [];

    if (searchString !== '') {
      results = suggestions;
    }

    this.setState({
      results
    })
  }

  handleNewRequest = (value) => {
    const {
      customerType,
      salesChannelName,
      strictMedicalCustomerType,
    } = this.props;

    getSearchSuggestions(value, customerType, salesChannelName, strictMedicalCustomerType)
      .then(({data}) => {
        if (!data && !data.data) {
          return;
        }
        
        const suggestions = data.data;
        this.saveResult(suggestions);
      });
  }

  onChange = (searchString) => {
    this.setState({ searchString });
    if (searchString && searchString.length > 0) {
      this.debouncedSuggestions(searchString);
    }
    if (searchString === '') {
      this.setState({
        results: [],
      })
    }
  };

  clear = () => {
    this.setState({
      results: [],
      searchString: '',
    })
  }

  onSubmit = (searchString) => {
    this.props.history.push(getSearchQueryUrl(searchString));
  };

  onResultClick = (result) => {
    console.log('result => ', result);
  };

  render() {
    return (
      <div>
        <SearchBarMobile
          clear={this.clear}
          onClose={this.props.goBack}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          onResultClick={this.onResultClick}
          results={this.state.results}
          value={this.state.searchString}
          secondaryColor={this.props.secondaryColor}
          customerType={this.props.customerType}
          salesChannelName={this.props.salesChannelName}
        />
      </div>
    )
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search/Search.jsx